export const CssVariables = {
  '--font-family-primary': { type: 'font' },
  '--primary': { type: 'hex-color' },
  '--primary-lighter-rgb': { type: 'rgb-color' },
  '--primary-light': { type: 'hex-color' },
  '--primary-400-rgb': { type: 'rgb-color' },
  '--primary-dark': { type: 'hex-color' },
  '--primary-darker': { type: 'hex-color' },
  '--primary-900-rgb': { type: 'rgb-color' },
  '--secondary': { type: 'hex-color' },
  '--secondary-light': { type: 'hex-color' },
  '--secondary-dark': { type: 'hex-color' },
  '--background': { type: 'hex-color' },
} as const;

export type CssVariableTypes = (typeof CssVariables)[keyof typeof CssVariables]['type'];
